<template>
  <span>
    <select v-if="!params.locked()" class="mt-1 p-1 rounded-1 w-100" v-model="selection" @change="onLEASelected">
      <option value=''>(Select)</option>
      <template v-if="params.isDistrictAdmin()">
        <option :value="params.districtLEA" :class="optionClass(params.districtLEA)">{{ params.districtLEA }} </option>
        <option v-for="s in contextSchools" :key="s.lea" :value="s.lea" :class="optionClass(s.lea)">{{ s.lea }} </option>
      </template>
      <template v-if="params.isSchoolAdmin()">
        <option v-for="s in administeredSchools" :key="s.lea" :value="s.lea" :class="optionClass(s.lea)">{{ s.lea }} </option>
      </template>
    </select>
    <span v-else-if="params.locked()">(Not Assigned)</span>
  </span>
</template>

<style scoped>
  .default-role {
    font-weight: bold;
  }
</style>

<script lang="js">
import Vue from 'vue'
import { injectStrict } from "@/lib/utils";
import { UserStoreKey } from "@/store/StoreInjectionKeys";
import useLeaMetadata from "@/modules/ees/dataProviders/leaMetadata"

export default Vue.extend({
  data: function () {
    return {
      selection: '',
      choices: [],
      contextSchools: [],
      administeredSchools: []
    }
  },
  beforeMount() {
    this.contextSchools = this.params.contextSchools.value
    this.administeredSchools = this.params.administeredSchools.value
    this.selection = this.params.data.learnerBuildingLEA || ''
    this.choices = [...new Set(this.params.data.roleSelectionMetadataItems.map(s=>s.schoolLEA))]
  },
  methods: {
    onLEASelected() {
      if (this.params.data.learnerBuildingLEA != this.selection) {
        this.params.data.learnerBuildingLEA = this.selection
        this.params.updateCallback(this.params.data)
      }
    },
    optionClass(lea) {
      return this.choices.filter(r => r == lea).length ? 'default-role' : ''
    }
  }
})

</script>